import { createAction, createErrorAction } from '../../actions/actionCreator';
import {
  GetDailyClearingsOptions,
  ManualUploadOptions,
  GetDailyClearingsResponse,
  GetMonthlyClearingsOptions,
  GetMonthlyClearingsResponse
} from '@card/commonlib';
import { ActionsType } from '@card/types';

export enum ClearingsActionType {
  FetchDailyStarted = 'clearings/fetchDailyStarted',
  FetchDailySuccess = 'clearings/fetchDailySuccess',
  FetchDailyError = 'clearings/fetchDailyError',
  CreateReportStarted = 'clearings/createReportStarted',
  CreateReportError = 'clearings/createReportError',
  ManualUploadStarted = 'clearings/manualUploadStarted',
  ManualUploadError = 'clearings/manualUploadError',
  ManualUploadSuccess = 'clearings/manualUploadSuccess',
  FetchMonthlyStarted = 'clearings/fetchMonthlyStarted',
  FetchMonthlySuccess = 'clearings/fetchMonthlySuccess',
  FetchMonthlyError = 'clearings/fetchMonthlyError'
}

export const ClearingsActions = {
  fetchDailyStarted: (params: GetDailyClearingsOptions) =>
    createAction(ClearingsActionType.FetchDailyStarted, params),
  fetchDailySuccess: (data: GetDailyClearingsResponse) =>
    createAction(ClearingsActionType.FetchDailySuccess, data),
  fetchDailyError: (error: Error) => createErrorAction(ClearingsActionType.FetchDailyError, error),
  createReportStarted: (params: GetDailyClearingsOptions) =>
    createAction(ClearingsActionType.CreateReportStarted, params),
  createReportError: (error: Error) =>
    createErrorAction(ClearingsActionType.CreateReportError, error),
  fetchMonthlyStarted: (params: GetMonthlyClearingsOptions) =>
    createAction(ClearingsActionType.FetchMonthlyStarted, params),
  fetchMonthlySuccess: (data: GetMonthlyClearingsResponse) =>
    createAction(ClearingsActionType.FetchMonthlySuccess, data),
  fetchMonthlyError: (error: Error) =>
    createErrorAction(ClearingsActionType.FetchMonthlyError, error),
  manualUploadStarted: (params: ManualUploadOptions) =>
    createAction(ClearingsActionType.ManualUploadStarted, params),
  manualUploadError: (error: Error) =>
    createErrorAction(ClearingsActionType.ManualUploadError, error),
  manualUploadSuccess: () => createAction(ClearingsActionType.ManualUploadSuccess)
};

export type ClearingsAction = ActionsType<typeof ClearingsActions>;
